import { AbstractControl, FormBuilder, ValidationErrors, Validators } from '@angular/forms';

import { passwordRules } from './password-field/password-field.component';

/** "Confirm password" must match "New password". */
function sameAs(otherName: string) {
  return (control: AbstractControl): ValidationErrors | null => {
    const other = control.parent?.get(otherName);
    if (!other || !control.value) return null;
    return control.value === other.value ? null : { mismatch: true };
  };
}

/** New password + confirmation, as used by reset and first-sign-in pages. */
export function newPasswordForm(fb: FormBuilder) {
  const form = fb.group({
    password: ['', [Validators.required, passwordRules]],
    confirm: ['', [Validators.required, sameAs('password')]],
  });
  // Re-check the confirmation whenever the first field changes.
  form.controls.password.valueChanges.subscribe(() => form.controls.confirm.updateValueAndValidity({ emitEvent: false }));
  return form;
}
